import { render, staticRenderFns } from "./ManagementServicePage.vue?vue&type=template&id=c4748ae6&scoped=true&"
import script from "./ManagementServicePage.vue?vue&type=script&lang=js&"
export * from "./ManagementServicePage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=c4748ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4748ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VLayout,VMain})
